var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.as,_vm._g(_vm._b({tag:"component",staticClass:"z-menu-item flex gap-2 leading-none outline-none focus:outline-none",class:[
    _vm.alignment,
    _vm.spacing,
    _vm.disabled ? 'cursor-not-allowed text-vanilla-400' : 'cursor-pointer hover:bg-ink-200'
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.itemClicked}},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('z-icon',{class:_vm.iconClasses,attrs:{"icon":_vm.icon,"size":_vm.iconSize,"color":_vm.computedIconColor}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }